import axios from "axios";

const baseUrl = process.env.REACT_APP_BACKEND_URL;

export const api = axios.create({
  baseURL: `${baseUrl}/api`,
});

export function setAuthToken(token) {
  if (token) {
    api.defaults.headers.common.Authorization = `Bearer ${token}`;
  } else {
    delete api.defaults.headers.common.Authorization;
  }
}

export function getErrorMessage(error) {
  const detail = error.response?.data?.detail;
  if (Array.isArray(detail)) {
    return detail.map((item) => item.msg).join(" ");
  }
  return detail || "Something went wrong. Please try again.";
}